import { render, staticRenderFns } from "./EnterMarks.vue?vue&type=template&id=a89c174c&scoped=true"
import script from "./EnterMarks.vue?vue&type=script&lang=js"
export * from "./EnterMarks.vue?vue&type=script&lang=js"
import style0 from "./EnterMarks.vue?vue&type=style&index=0&id=a89c174c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c174c",
  null
  
)

export default component.exports